import { render } from "./SignupConfirm.vue?vue&type=template&id=e08a1ae2&ts=true"
import script from "./SignupConfirm.vue?vue&type=script&lang=ts"
export * from "./SignupConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1488180328/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__